/* eslint-disable */

import React, { useState } from "react";
import Quote from "../components/Quote/Index";



const QuotePage = () => {
    const [payload, setPayload] = useState({
        weight: 0,
        container: ""
    });

    const handleChange = (field, value) => {
        setPayload((prev) => ({ ...prev, [field]: value }));
    }

    return (
        <>
            <Quote handleChange={handleChange} payload={payload} />
        </>
    )
}

export default QuotePage;